var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame-view"},[(_vm.canLoad)?_c('iframe',{ref:"frame",attrs:{"id":"view-frame","srcdoc":_vm.srcdoc}}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"spinner"},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }